<script lang="ts">
	import { IconButton, Tooltip } from '@Shelly/shelly-design-system';

	export let text = '';
</script>

{#if text}
	<Tooltip placement="top" title={text}>
		<IconButton
			class="em-info-tooltip-trigger"
			icon="fa-light fa-circle-info"
			size="s"
			variant="secondary"
			aria-label={text}
		/>
	</Tooltip>
{/if}
